import * as core from '../../../core';
import { inferParsedObject } from '../../../core/schemas';
import { vcdmDocumentSchema, vcdmProofSetSchema } from '../document/vcdm';
import type { CredentialBlob, CredentialMetadata, DocumentFlavor } from '../types';
import { Vcdm11Flavor } from './vcdm1_1';

export const vcdm22DocumentSchema = core.serialization
    .object({
        id: core.serialization.string(),
        holder: core.serialization.string().optional(),
        issuer: core.serialization.undiscriminatedUnion([
            core.serialization.string(),
            core.serialization.object({
                id: core.serialization.string(),
                name: core.serialization.string().optional(),
                description: core.serialization.string().optional(),
            }),
        ]),
        validFrom: core.serialization.date().optional(),
        validTo: core.serialization.date().optional(),
        proof: vcdmProofSetSchema,
    })
    .extend(vcdmDocumentSchema);

export type Vcdm22Document = inferParsedObject<typeof vcdm22DocumentSchema>;

export class Vcdm20Flavor extends Vcdm11Flavor implements DocumentFlavor {
    kind = 'vcdm2_0';

    private blobToVcdm22(input: CredentialBlob): Promise<Vcdm22Document> {
        return this.parseBlob(vcdm22DocumentSchema, input);
    }

    async isOfFlavor(blob: CredentialBlob): Promise<boolean> {
        try {
            await this.blobToVcdm22(blob);
        } catch {
            return false;
        }
        return true;
    }

    async getMetadata(blob: CredentialBlob): Promise<CredentialMetadata> {
        const credential = await this.blobToVcdm22(blob);

        return {
            id: credential.id,
            issuer: typeof credential.issuer === 'string' ? credential.issuer : credential.issuer.id,
            validFrom: credential.validFrom,
            validUntil: credential.validTo,
            subject: credential.credentialSubject.id,
            holder: credential.holder,
        };
    }
}
